const LEADERSHIP_HD_TEAM = 'Leadership';

function teamsMatchTeam(a, b) {
    const x = String(a || '')
        .trim()
        .toLowerCase();
    const y = String(b || '')
        .trim()
        .toLowerCase();
    return x.length > 0 && x === y;
}

/**
 * True when the user has IT Leadership (admin) in Mongo / API payloads.
 * Handles boolean, numeric, and string shapes that sometimes appear after BSON/JSON.
 */
export function userHasLeadershipAdminRole(u) {
    if (!u || typeof u !== 'object') return false;
    const v = u.isItLeadership;
    if (v === true) return true;
    if (v === 1) return true;
    if (typeof v === 'string') {
        const s = v.trim().toLowerCase();
        return s === 'true' || s === '1' || s === 'yes';
    }
    return false;
}

/**
 * Merge users from GET /users/manage?role=admin into the Leadership team group.
 * Team tasks sidebar uses GET /dashboard/team-users, which may omit isItLeadership on nested
 * users — this uses the same admin source of truth as CreateTaskModal / user management.
 */
export function mergeAdminUsersIntoLeadershipTeamGroup(teamGroups, adminUsers) {
    if (!teamGroups?.length) return teamGroups || [];
    if (!adminUsers?.length) return teamGroups;

    const leadIdx = teamGroups.findIndex((g) =>
        teamsMatchTeam(g.team, LEADERSHIP_HD_TEAM)
    );

    let leadershipUsers =
        leadIdx >= 0 ? [...(teamGroups[leadIdx].users || [])] : [];

    const seen = new Set(
        leadershipUsers.map((u) =>
            String(u.email || '')
                .trim()
                .toLowerCase()
        )
    );

    adminUsers.forEach((admin) => {
        const em = String(admin.email || '')
            .trim()
            .toLowerCase();
        if (!em || seen.has(em)) return;
        seen.add(em);
        leadershipUsers.push({
            firstName: admin.firstName,
            lastName: admin.lastName,
            email: admin.email,
            hdTeam: admin.hdTeam ?? null,
            isItLeadership: true
        });
    });

    leadershipUsers = leadershipUsers.sort((a, b) => {
        const nameA = `${a.firstName || ''} ${a.lastName || ''}`;
        const nameB = `${b.firstName || ''} ${b.lastName || ''}`;
        return nameA.localeCompare(nameB);
    });

    if (leadIdx >= 0) {
        return teamGroups.map((g, i) =>
            i === leadIdx ? { ...g, users: leadershipUsers } : g
        );
    }

    if (leadershipUsers.length === 0) return teamGroups;

    return [
        ...teamGroups,
        { team: LEADERSHIP_HD_TEAM, users: leadershipUsers }
    ];
}
